// client/src/components/ChunkErrorBoundary.jsx
import React from 'react';

// Wraps lazy-loaded (React.lazy) route or component boundaries. If a
// chunk's JS or CSS fails to load — most commonly because the browser is
// holding an index.html that references a build hash which no longer
// exists after a fresh deploy — this does ONE silent reload to pick up
// the current build instead of leaving a permanently blank screen.
// The sessionStorage guard stops a reload loop if the failure isn't
// actually chunk-related.
class ChunkErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error) {
    const isChunkError = /ChunkLoadError|Loading chunk|Loading CSS chunk/i.test(
      error?.message || error?.name || ''
    );
    const alreadyRetried = sessionStorage.getItem('chunk-reload-attempted');

    if (isChunkError && !alreadyRetried) {
      sessionStorage.setItem('chunk-reload-attempted', '1');
      window.location.reload();
      return;
    }

    console.error('[ChunkErrorBoundary]', error);
  }

  render() {
    if (this.state.hasError) {
      // A reload is already in flight for chunk errors. For anything
      // else, fail quietly rather than leaving the whole app unmounted.
      return null;
    }
    return this.props.children;
  }
}

export default ChunkErrorBoundary;
